<template>
  <div class="loginPage">
		<div class="loginComponent">
			<registration-form></registration-form>
		</div>
  </div>
</template>

<script>
export default {
	name: 'RegistrationPage',
	props: {
	},
	metaInfo: {
		title: 'User Registration'
	}
}
</script>
<style>
</style>
